import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { camelize } from '@ridi/object-case-converter';

import { BookDetailContextType, BookDetailContext } from 'app/pages/bookDetail/components/BookDetailContext';
import { BookEvent } from 'app/pages/bookDetail/components/Notice/items/NoticeEventItem';
import { Notice } from 'app/pages/bookDetail/components/Notice/Notice';

export interface Time {
  date: string;
  timezone: string;
  timezone_type: number;
}

export interface BookBenefit {
  b_id: string;
  detail_message: string;
  id: number;
  is_enabled: boolean;
  title: string;
  url: string;
  end_time: Time;
  start_time: Time;
}

export interface NoticeProps {
  noticeTargetElementId: string;
  events: BookEvent[];
  bookBenefits: BookBenefit[];
}

interface SelectInfoProps {
  selectInfoTargetElementId: string;
  haveRidiSelectBookInSetBooks: boolean;
  setBookElementId: string;
  isRidiSelectBook: boolean;
  ridiSelectDetailUrl: string;
}

/*
  도서 상세에 표시되는
  혜택, 리다무, 셀렉트, 라프텔, 공지, 연재, 이벤트 에 대해 정리가 필요함.
  현재는 정보 출처도 혼동되고 코드도 엉망
 */
window.addEventListener('bookDetailLoad', (event: CustomEvent<NoticeProps & SelectInfoProps & BookDetailContextType>) => {
  const {
    noticeTargetElementId,
    selectInfoTargetElementId,
    events,
    bookId,
    bookApiUrl,
    apiServerUrl,
    haveRidiSelectBookInSetBooks,
    setBookElementId,
    isRidiSelectBook,
    categoryName,
    ridiSelectDetailUrl,
    bookBenefits,
    isVerifiedAdult,
    adultBookCover,
    featureGuard,
  } = event.detail;

  const detailContext = {
    bookId,
    categoryName,
    bookApiUrl,
    apiServerUrl,
    isVerifiedAdult,
    adultBookCover,
    featureGuard,
  };

  const target = document.getElementById(noticeTargetElementId);
  if (!target) {
    return;
  }

  ReactDOM.render(
    <BookDetailContext.Provider value={detailContext}>
      <ul className="NoticeWrapper">
        <Notice
          events={camelize(events)}
          benefits={bookBenefits}
          haveRidiSelectBookInSetBooks={haveRidiSelectBookInSetBooks}
          setBookElementId={setBookElementId}
          isRidiSelectBook={isRidiSelectBook}
          ridiSelectDetailUrl={ridiSelectDetailUrl}
        />
      </ul>
    </BookDetailContext.Provider>,
    target,
  );

  // ** Select도 Notice쪽으로 컴포넌트 병합시켰음
  // ReactDOM.render(
  //   <SelectInfo
  //     haveRidiSelectBookInSetBooks={haveRidiSelectBookInSetBooks}
  //     setBookElementId={setBookElementId}
  //     isRidiSelectBook={isRidiSelectBook}
  //     ridiSelectDetailUrl={ridiSelectDetailUrl}
  //   />,
  //   document.getElementById(selectInfoTargetElementId),
  // );
});



// WEBPACK FOOTER //
// ./bookDetail.tsx